// Eén singleton-listener (UmlCanvasToolbar, altijd gemount) — een directe
// functie-referentie is simpeler dan ComponentNotifier-pub/sub, want er is
// maar 1 aanroeper (S-key, UmlCanvas.useConnectorKeyboardShortcuts.js) en
// 1 listener, geen broadcast nodig.
let listener = null;

/**
 * @param {Function|null} fn - UmlCanvasToolbar.handleUpdatePreview, or null on unmount
 */
export function setPreviewUpdateListener(fn) {
    listener = fn;
}

/**
 * Requests a preview-capture on the currently mounted listener, if any.
 */
export function requestPreviewUpdate() {
    listener?.();
}
